import { Component } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import {
  MunilyTextAreaFieldWidthLayout,
  MunilyTextAreaValueFormat,
} from '../../../common-components/text-area-field/text-area-field.types';

@Component({
  selector: 'app-text-area-field-playground',
  templateUrl: './text-area-field-playground.component.html',
  styleUrls: ['./text-area-field-playground.component.scss'],
})
export class TextAreaFieldPlaygroundComponent {
  readonly widthLayouts: MunilyTextAreaFieldWidthLayout[] = ['ds', 'fill'];
  readonly valueFormats: MunilyTextAreaValueFormat[] = ['html', 'plain'];

  widthLayout: MunilyTextAreaFieldWidthLayout = 'fill';
  valueFormat: MunilyTextAreaValueFormat = 'plain';
  maxWidthCustom = '';
  label = 'Descripción';
  placeholder = 'Escribe el mensaje…';
  hint = 'Negrita, cursiva, listas y enlaces.';
  minHeightPx = 120;
  disabled = false;
  successful = false;

  hasCharacterCounter = true;
  /** `null` = contador sin “/ máximo” (solo total). */
  maxCharacters: number | null = 500;

  descriptionControl = new FormControl('', Validators.required);

  markTouched(): void {
    this.descriptionControl.markAsTouched();
  }
}
